<template>
    <aside class="menu tw:text-base" v-bind="$attrs">
        <slot />
    </aside>
</template>

<script>
/**
 * EMenu - Abstraction wrapper to replicate Buefy b-menu functionality
 *
 * Usage:
 *   <e-menu>
 *     <e-menu-list label="Navigation">
 *       <e-menu-item icon="home" label="Home" />
 *       <e-menu-item icon="cog" label="Settings" />
 *       <e-menu-item icon="user" label="Profile" />
 *     </e-menu-list>
 *   </e-menu>
 *
 *   <e-menu>
 *     <e-menu-list label="Actions">
 *       <e-menu-item label="Edit" @click="handleEdit" />
 *       <e-menu-item label="Delete" @click="handleDelete" />
 *     </e-menu-list>
 *   </e-menu>
 *
 * All Buefy b-menu props, events, and slots are supported in Buefy mode.
 */
export default {
    name: 'EMenu',
};
</script>

